import { render } from "./ProductHighlights.vue?vue&type=template&id=4517a3d5&scoped=true"
import script from "./ProductHighlights.vue?vue&type=script&lang=js"
export * from "./ProductHighlights.vue?vue&type=script&lang=js"

import "./ProductHighlights.vue?vue&type=style&index=0&id=4517a3d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4517a3d5"]])

export default __exports__